import { render, staticRenderFns } from "./Alaune.vue?vue&type=template&id=19e177d9&lang=html&"
import script from "./Alaune.vue?vue&type=script&lang=js&"
export * from "./Alaune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports